import { render } from "./DisplayDebug.vue?vue&type=template&id=20eb7d52&scoped=true"
import script from "./DisplayDebug.vue?vue&type=script&lang=js"
export * from "./DisplayDebug.vue?vue&type=script&lang=js"

import "./DisplayDebug.vue?vue&type=style&index=0&id=20eb7d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20eb7d52"]])

export default __exports__